import { getParameterByName } from "../utils/urlParser";

const REGISTER_SETTINGS_API_URL = "/register/settings";
const SMSLOGIN_SETTINGS_API_URL = "/smslogin/settings";
const VIPPSLOGIN_SETTINGS_API_URL = "/vipps/settings";
const LOGIN_SETTINGS_API_URL = "/login/settings";
const PASSWORD_SETTINGS_API_URL = "/password/settings";
const LOGOUT_SETTINGS_API_URL = "/logout/settings";
const VALIDATE_SETTINGS_API_URL = "/twofactor/settings";

const returnUrl = encodeURIComponent(getParameterByName("returnUrl"));

function callApi({ path, method, data, headers = {} }) {
	const apiUrl = path;
	let requestData = {
		method,
		headers: new Headers(headers),
		credentials: "same-origin",
		body: JSON.stringify(data),
	};

	return fetch(apiUrl, requestData)
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
		})
		.catch((e) => {
			throw new Error(e);
		});
}

export function postToApi(path, data) {
	const tokenData = document.getElementById("antiForgeryTokenData");

	const tokenHeaders = tokenData
		? {
				[tokenData.getAttribute("data-header-name")]:
					tokenData.getAttribute("data-token"),
			}
		: {};

	const headers = {
		...tokenHeaders,
		["Accept"]: "application/json",
		["Content-Type"]: "application/json",
	};

	return callApi({ path, method: "POST", data, headers });
}

export function getFromApi(path) {
	return callApi({ path, method: "GET" });
}

export function getSettings(layout) {
	switch (layout) {
		case "smslogin":
			return getSmsLoginSettings();
		case "register":
			return getRegisterSettings();
		case "vipps":
			return getVippsLoginSettings();
		case "login":
			return getLoginSettings();
		case "password":
			return getPasswordSettings();
		case "logout":
			return getLogoutSettings();
		case "twofactor":
			return getValidateSettings();
		default:
			return "";
	}
}

function getRegisterSettings() {
	return getFromApi(`${REGISTER_SETTINGS_API_URL}?returnUrl=${returnUrl}`);
}

function getSmsLoginSettings() {
	return getFromApi(SMSLOGIN_SETTINGS_API_URL);
}

function getVippsLoginSettings() {
	return getFromApi(`${VIPPSLOGIN_SETTINGS_API_URL}?returnUrl=${returnUrl}`);
}

function getLoginSettings() {
	return getFromApi(`${LOGIN_SETTINGS_API_URL}?returnUrl=${returnUrl}`);
}

function getPasswordSettings() {
	return getFromApi(`${PASSWORD_SETTINGS_API_URL}?returnUrl=${returnUrl}`);
}

function getLogoutSettings() {
	return getFromApi(LOGOUT_SETTINGS_API_URL);
}

function getValidateSettings() {
	return getFromApi(VALIDATE_SETTINGS_API_URL);
}
